<template>
    <div class="float-left mr-2">
        <span class="text-primary">
            <i
                class="fa fa-download fa-lg icon-button"
                title="Download"
                @click.stop="download()"
            ></i>
        </span>
    </div>
</template>

<script>
import SegurosServicos from './SegurosServicos'

export default {
    props: {
        seguro: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        download() {
            this.$store.dispatch('addRequest')
            SegurosServicos.download(this.seguro).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.seguro.documentoComprobatorio)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
